(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["description-media-slider"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var slider = document.querySelector('[data-shaw-media-slider="{{ section.id }}"]');
    if (!slider) return;

    var track = slider.querySelector('.shaw-media-track');
    if (!track) return;

    var prevBtn = slider.querySelector('.shaw-media-btn-prev');
    var nextBtn = slider.querySelector('.shaw-media-btn-next');

    function getStep() {
      // mutam cam cu jumatate de zona vizibila
      return track.clientWidth * 0.8;
    }

    function scrollByDir(dir) {
      var step = getStep();
      track.scrollTo({
        left: track.scrollLeft + dir * step,
        behavior: 'smooth'
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        scrollByDir(-1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        scrollByDir(1);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
